import { useTheme } from '../lib/theme-provider';

interface MissionProgressProps {
  missions: {
    round: number;
    players: number;
    status: 'pending' | 'success' | 'fail' | 'current';
  }[];
}

export default function MissionProgress({ missions }: MissionProgressProps) {
  const { theme } = useTheme();

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'success':
        return '#4ade80';
      case 'fail':
        return '#f87171';
      case 'current':
        return theme.colors['accent-gold'];
      default:
        return `${theme.colors['border-secondary']}40`;
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'success':
        return '✓';
      case 'fail':
        return '✗';
      case 'current':
        return '';
      default:
        return '';
    }
  };

  return (
    <div className="flex items-center justify-center gap-2 py-2">
      {missions.map((mission, index) => (
        <div key={mission.round} className="flex items-center">
          <div
            className="relative flex flex-col items-center justify-center"
            style={{ width: 36, height: 36 }}
          >
            {/* 圆形背景 */}
            <div
              className="absolute inset-0 rounded-full flex items-center justify-center text-sm font-bold"
              style={{
                backgroundColor:
                  mission.status === 'current'
                    ? `${getStatusColor(mission.status)}20`
                    : getStatusColor(mission.status),
                border: `2px solid ${getStatusColor(mission.status)}`,
                color:
                  mission.status === 'success'
                    ? theme.colors['bg-primary']
                    : mission.status === 'fail'
                    ? theme.colors['bg-primary']
                    : mission.status === 'current'
                    ? theme.colors['accent-gold']
                    : theme.colors['text-secondary'],
              }}
            >
              {getStatusText(mission.status) || mission.players}
            </div>
            {/* 当前轮发光效果 */}
            {mission.status === 'current' && (
              <div
                className="absolute inset-0 rounded-full animate-pulse"
                style={{
                  border: `2px solid ${theme.colors['accent-gold']}`,
                  boxShadow: `0 0 10px ${theme.colors['accent-gold']}`,
                }}
              />
            )}
          </div>
          {/* 连接线 */}
          {index < missions.length - 1 && (
            <div
              className="w-4 h-0.5 mx-1"
              style={{ backgroundColor: theme.colors['border-secondary'] }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
